import { QuerySpec } from "csi/core/Spec";
import { Context } from "csi/def/Context";
import Heading from "csi/def/Heading";
import String from "csi/heading/String";
import { getNodeAttributeImageSrc } from "csi/model/image";
import { cssCheckeredBackground } from "designSystem/components/colorPicker/ColorPicker";
import { white } from "designSystem/styles/color";
import declare from "dojo/_base/declare";
import domConstruct from "dojo/dom-construct";
import Spec from "../heading/Spec";

const BackgroundColorRenderer = declare(String, {
	/**
	 * @override
	 * Do not allow filtering/sorting since renderer is either rendering a color chip or an image
	 */
	getQuerySpec(ctx: Context, h: Heading, spec: Spec): QuerySpec {
		return null;
	},

	/**
	 * @override
	 * Use the string stored in the attribute to create a color chip showing the color
	 */
	toHtmlStatic(ctx, h, refNode, actionData) {
		const node = ctx.getNode();
		const colorHex = this._getValue(ctx, h);
		const showEnvironment = node.Use3DEnvironmentAsBackground;	

		if (showEnvironment) {
			const environmentURL = node.ThreeDEnvironment;
			const environmentNode = ctx.cache.get(environmentURL);
			const path = getNodeAttributeImageSrc(environmentNode, "EnvironmentImage");

			const element = domConstruct.create(
				"div", 
				{ class: "snapshot-template-background-image" }, 
				refNode,
			);
			element.style.background = `url(${path})`;
			element.style.backgroundSize = "cover";
			element.style.backgroundPosition = "center";
			element.style.backgroundRepeat = "no-repeat";
		} else {
			const element = domConstruct.create(
				"div", 
				{ class: "snapshot-template-background-color" }, 
				refNode,
			);
			element.style.background = `linear-gradient(${colorHex}, ${colorHex}),  ${cssCheckeredBackground}`;
			if (colorHex === "transparent") {
				domConstruct.create(
					"div", 
					{ class: "snapshot-template-transparency" }, 
					element,
				);
				element.style.background = white[50];
			}
		}

		return true;
	}, 
});

export = BackgroundColorRenderer;
